import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initObservability } from '@/config/observability';
// Self-hosted app fonts, matching xonera-landing-page so both properties render
// identically. Inter Variable carries all text; JetBrains Mono is the label and
// numeral register (see the `.eyebrow` utility in globals.css) and only needs
// the two weights the landing page pins.
import '@fontsource-variable/inter';
// Variable, not the static weights. Two sites already ask for 600 against a
// face that only had 400 and 500 loaded, so the browser was synthesizing a fake
// bold — visibly wrong on a monospace. The variable file carries every weight
// in roughly the size of two static ones, so the whole range is available
// without paying per weight.
import '@fontsource-variable/jetbrains-mono';
import './styles/globals.css';
// KaTeX stylesheet for rendered LaTeX math (rehype-katex). Must load globally
// so formulas across all markdown surfaces are styled.
import 'katex/dist/katex.min.css';

initObservability();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
